import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import { Upload } from '../types/backend-dto-types';
import useGetFetchConfig from '../useGetFetchConfig';

export const useGetUpload = (matterId: string | undefined, uploadId: string | undefined) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Upload>(
    [QueryEntity.UploadHistory, { matterId, uploadId }],
    () => {
      return fetch(`${APIBaseChronos}/api/matter/${matterId}/upload-metadata/${uploadId}`, fetchConfigGET).then(
        (res) => {
          return res.json();
        },
      );
    },
    {
      enabled: !!matterId && !!uploadId,
      refetchOnWindowFocus: false,
    },
  );
};
